import React from 'react';

const FormTextArea = React.forwardRef(({type, label, value, setValue, error, placeholder = '', height = ''}, ref) => {
	if (placeholder === '') {
		placeholder = label;
	}

	const showMeta = label !== '' || error !== '';

	return (
		<div className={`input-div${error !== '' ? ' has-error' : ''}`}>
			{showMeta ? (
				<div className="input-meta">
					<div className="input-meta-left">
						{label !== '' ? <div className="input-label">{label}</div> : ''}
					</div>
					{error !== '' ? <div className="input-error">{error}</div> : ''}
				</div>
			) : ''}
			<div className="input-control">
				<textarea className="input-textarea" style={{height: height !== '' ? height : '7rem'}} placeholder={placeholder} ref={ref} value={value} onChange={(e) => setValue(e.target.value)}>
					{value}
				</textarea>
			</div>
		</div>
	);
});

export default FormTextArea;
